import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  OnInit,
  OnDestroy,
  inject,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

@Component({
  selector: 'app-toast',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css',
})
export class ToastComponent implements OnInit, OnDestroy {
  private readonly platformId = inject(PLATFORM_ID);
  private timeoutId: ReturnType<typeof setTimeout> | null = null;

  readonly type = input<ToastType>('info');
  readonly message = input.required<string>();
  readonly duration = input(5000);
  readonly dismissible = input(true);
  readonly dismissed = output<void>();

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId) && this.duration() > 0) {
      this.timeoutId = setTimeout(() => {
        this.dismiss();
      }, this.duration());
    }
  }

  ngOnDestroy(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  dismiss(): void {
    this.dismissed.emit();
  }
}
